/* eslint-disable react/jsx-pascal-case */
/* ===========================================================
   키즈다 뉴스 — 공통 아이콘 & UI 헬퍼
   원본 오프라인 프로토타입에서 이식 (window 전역 → ES 모듈)
   =========================================================== */
import React from "react";

/* ---- Icons (line, 1.8 stroke) ---- */
export const Ico = {
  search: (p) => <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}><circle cx="11" cy="11" r="7" /><path d="m20 20-3.2-3.2" /></svg>,
  menu: (p) => <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" {...p}><path d="M3 6h18M3 12h18M3 18h18" /></svg>,
  close: (p) => <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" {...p}><path d="M6 6l12 12M18 6L6 18" /></svg>,
  chevR: (p) => <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="m9 6 6 6-6 6" /></svg>,
  chevL: (p) => <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="m15 6-6 6 6 6" /></svg>,
  chevD: (p) => <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="m6 9 6 6 6-6" /></svg>,
  arrow: (p) => <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M5 12h14M13 6l6 6-6 6" /></svg>,
  eye: (p) => <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z" /><circle cx="12" cy="12" r="2.6" /></svg>,
  clock: (p) => <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" {...p}><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></svg>,
  fire: (p) => <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" {...p}><path d="M12 2c.3 2.6-1.2 3.9-2.5 5.3C8 8.8 6.8 10.3 6.8 12.6 6.8 16 9.2 18.5 12 18.5s5.2-2.5 5.2-5.9c0-1.7-.7-3-1.6-4.2.2 1.1-.2 2-.9 2.6.3-2.2-.6-4.6-2.7-6 .4 1.6-.2 2.6-1 3.4C10.8 5 11.3 3.4 12 2Z" /></svg>,
  bookmark: (p) => <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M6 4h12v16l-6-4-6 4Z" /></svg>,
  share: (p) => <svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" {...p}><circle cx="18" cy="5" r="2.6" /><circle cx="6" cy="12" r="2.6" /><circle cx="18" cy="19" r="2.6" /><path d="m8.3 10.7 7.4-4.4M8.3 13.3l7.4 4.4" /></svg>,
  bell: (p) => <svg viewBox="0 0 24 24" width="19" height="19" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M18 8a6 6 0 1 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" /><path d="M13.7 21a2 2 0 0 1-3.4 0" /></svg>,
  user: (p) => <svg viewBox="0 0 24 24" width="19" height="19" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" {...p}><circle cx="12" cy="8" r="4" /><path d="M4 21a8 8 0 0 1 16 0" /></svg>,
  plus: (p) => <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" {...p}><path d="M12 5v14M5 12h14" /></svg>,
  check: (p) => <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="m5 12.5 4.5 4.5L19 7" /></svg>,
  image: (p) => <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}><rect x="3" y="4" width="18" height="16" rx="2.5" /><circle cx="8.5" cy="9.5" r="1.8" /><path d="m4 17 4.5-4.5 4 4 3-3L20 17" /></svg>,
  doc: (p) => <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8Z" /><path d="M14 3v5h5M8.5 13h7M8.5 17h5" /></svg>,
  grid: (p) => <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}><rect x="3" y="3" width="7" height="7" rx="1.5" /><rect x="14" y="3" width="7" height="7" rx="1.5" /><rect x="3" y="14" width="7" height="7" rx="1.5" /><rect x="14" y="14" width="7" height="7" rx="1.5" /></svg>,
  list: (p) => <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M8 6h13M8 12h13M8 18h13M3.5 6h.01M3.5 12h.01M3.5 18h.01" /></svg>,
  trash: (p) => <svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M4 7h16M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2M6 7l1 13a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1l1-13" /></svg>,
  edit: (p) => <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M12 20h9M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z" /></svg>,
  spark: (p) => <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" {...p}><path d="M12 2l1.8 6.2L20 10l-6.2 1.8L12 18l-1.8-6.2L4 10l6.2-1.8Z" /></svg>,
  play: (p) => <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" {...p}><path d="M7 5v14l11-7z" /></svg>,
  back: (p) => <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M19 12H5M11 6l-6 6 6 6" /></svg>,
  logout: (p) => <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9" /></svg>,
  download: (p) => <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M12 3v12M7 11l5 5 5-5M5 21h14" /></svg>,
};

/* ---- Thumbnail placeholder (intentional duotone) — pass `src` for a real image ---- */
export function Thumb({ hue = 215, label, ratio = "16/10", radius = 12, icon = true, src, children, style }) {
  const a = `hsl(${hue} 70% 58%)`, b = `hsl(${(hue + 28) % 360} 75% 44%)`;
  // ratio("16/11")를 padding-top 비율(높이=폭*h/w)로 환산 — aspect-ratio 미지원/중첩그리드에서도 확실히 고정
  const [rw, rh] = String(ratio).split("/").map((n) => parseFloat(n));
  const padTop = rw > 0 && rh > 0 ? (rh / rw) * 100 : 62.5;
  // 이미지가 있을 땐 로드 전 컬러 대신 중립 스켈레톤(shimmer)을 깔고, 이미지가 위를 덮음.
  // 이미지가 없을 때만 의도된 컬러 듀오톤 플레이스홀더 사용.
  return (
    <div
      className={src ? "kd-skel" : undefined}
      style={{
        position: "relative", width: "100%", height: 0, paddingTop: `${padTop}%`,
        borderRadius: radius, overflow: "hidden",
        ...(src ? {} : { background: `linear-gradient(135deg, ${a}, ${b})` }),
        ...style,
      }}
    >
      {src && <img src={src} alt={label || ""} style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }} />}
      {!src && <>
        <div style={{ position: "absolute", inset: 0, background:
            `radial-gradient(120px 120px at 78% 18%, rgba(255,255,255,.28), transparent 60%),
           radial-gradient(160px 160px at 18% 92%, rgba(0,0,0,.18), transparent 60%)` }} />
        <svg viewBox="0 0 100 100" preserveAspectRatio="none" style={{ position: "absolute", inset: 0, width: "100%", height: "100%", opacity: .16 }}>
          <circle cx="84" cy="22" r="26" fill="#fff" />
          <circle cx="14" cy="86" r="20" fill="#000" />
        </svg>
        {icon &&
          <div style={{ position: "absolute", inset: 0, display: "grid", placeItems: "center", color: "rgba(255,255,255,.85)" }}>
            <Ico.image width={38} height={38} />
          </div>}
      </>}
      {label &&
        <span style={{ position: "absolute", left: 10, top: 10, fontSize: 11, fontWeight: 800,
          color: "#fff", background: "rgba(0,0,0,.24)", backdropFilter: "blur(2px)",
          padding: "3px 9px", borderRadius: 99 }}>{label}</span>}
      {children}
    </div>
  );
}

/* ---- Category chip ---- */
export function CatTag({ color, children, solid = false, size = 12 }) {
  return (
    <span style={{
      display: "inline-flex", alignItems: "center", fontSize: size, fontWeight: 800, lineHeight: 1,
      padding: size > 12 ? "6px 11px" : "5px 9px", borderRadius: 7,
      whiteSpace: "nowrap",
      color: solid ? "#fff" : color,
      background: solid ? color : "color-mix(in srgb, " + color + " 12%, #fff)",
    }}>{children}</span>
  );
}

/* ---- Hashtags (#a #b #c) ----
   nowrap: 한 줄로만 표시하고 넘치면 말줄임표(…) — 컴팩트 리스트 카드 레이아웃 깨짐 방지 */
export function Hashtags({ tags, color = "var(--muted)", size = 13, gap = 7, max, nowrap = false }) {
  if (!tags || !tags.length) return null;
  const list = max ? tags.slice(0, max) : tags;

  if (nowrap) {
    return (
      <span
        style={{
          display: "block",
          maxWidth: "100%",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          fontSize: size,
          fontWeight: 600,
          color,
        }}
      >
        {list.map((t, i) => (
          <span key={i} style={{ marginRight: i < list.length - 1 ? gap : 0 }}>
            {t}
          </span>
        ))}
      </span>
    );
  }

  return (
    <span style={{ display: "inline-flex", flexWrap: "wrap", gap, fontSize: size, fontWeight: 600, color }}>
      {list.map((t, i) => <span key={i}>{t}</span>)}
    </span>
  );
}

/* ---- Rich body renderer (HTML or plain paragraphs) ---- */
export function RichBody({ body, className }) {
  if (!body) return null;
  const isHtml = /<[a-z][\s\S]*>/i.test(body);
  if (isHtml) return <div className={"kd-richbody " + (className || "")} dangerouslySetInnerHTML={{ __html: body }} />;
  return <div className={"kd-richbody " + (className || "")}>{body.split("\n\n").map((p, i) => <p key={i}>{p}</p>)}</div>;
}

/* ---- helpers ---- */
export const fmtViews = (n) => n >= 10000 ? (n / 10000).toFixed(1).replace(/\.0$/, "") + "만" : n.toLocaleString("ko-KR");
export function relDate(d) {
  const today = new Date();
  today.setHours(9, 0, 0, 0);
  const dt = new Date(d + "T09:00:00");
  const diff = Math.round((today - dt) / 86400000);
  if (diff <= 0) return "오늘";
  if (diff === 1) return "어제";
  if (diff < 7) return diff + "일 전";
  return d.slice(5).replace("-", ".");
}
